module.exports = __webpack_public_path__ + "img/error.96b78730.png";